var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunningIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96323 -0.000976562H8.03637C8.52161 -0.000976562 8.91412 0.484258 8.91412 0.876769V3.74324C8.91412 4.22847 8.52096 4.62098 8.03637 4.62098H7.96323C7.47799 4.62098 7.08548 4.13575 7.08548 3.74324V0.876769C7.08548 0.391535 7.47864 -0.000976562 7.96323 -0.000976562Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96323 11.3771H8.03637C8.52161 11.3771 8.91412 11.8623 8.91412 12.2548V15.1213C8.91412 15.6065 8.52096 15.999 8.03637 15.999H7.96323C7.47799 15.999 7.08548 15.5138 7.08548 15.1213V12.2548C7.08548 11.7696 7.47864 11.3771 7.96323 11.3771Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000488281 8.03588V7.96274C-0.000488281 7.4775 0.484746 7.08499 0.877258 7.08499H3.74372C4.22896 7.08499 4.62147 7.47816 4.62147 7.96274V8.03588C4.62147 8.52112 4.13624 8.91363 3.74372 8.91363H0.877258C0.392023 8.91363 -0.000488281 8.52047 -0.000488281 8.03588Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3776 8.03588V7.96274C11.3776 7.4775 11.8628 7.08499 12.2553 7.08499H15.1218C15.607 7.08499 15.9995 7.47816 15.9995 7.96274V8.03588C15.9995 8.52112 15.5143 8.91363 15.1218 8.91363H12.2553C11.7701 8.91363 11.3776 8.52047 11.3776 8.03588Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31666 2.36831L2.36825 2.31672C2.71112 1.97384 3.3322 2.0385 3.60977 2.31672L5.63628 4.34322C5.97915 4.6861 5.97915 5.24187 5.63628 5.58474L5.58468 5.63633C5.24181 5.97921 4.62073 5.91455 4.34316 5.63633L2.31666 3.60983C1.97379 3.26696 1.97379 2.71118 2.31666 2.36831Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3627 10.4137L10.4143 10.3621C10.7572 10.0192 11.3782 10.0839 11.6558 10.3621L13.6823 12.3886C14.0252 12.7315 14.0252 13.2873 13.6823 13.6301L13.6307 13.6817C13.2878 14.0246 12.6668 13.9599 12.3892 13.6817L10.3627 11.6552C10.0198 11.3123 10.0198 10.7566 10.3627 10.4137Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36885 13.6824L2.31726 13.6308C1.97438 13.288 2.03904 12.6669 2.31726 12.3893L4.34376 10.3628C4.68664 10.0199 5.24241 10.0199 5.58528 10.3628L5.63687 10.4144C5.97975 10.7573 5.91509 11.3783 5.63687 11.6559L3.61037 13.6824C3.2675 14.0253 2.71172 14.0253 2.36885 13.6824Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4142 5.63644L10.3626 5.58485C10.0198 5.24197 10.0844 4.6209 10.3626 4.34333L12.3891 2.31682C12.732 1.97395 13.2878 1.97395 13.6307 2.31682L13.6823 2.36842C14.0251 2.71129 13.9605 3.33237 13.6823 3.60993L11.6557 5.63644C11.3129 5.97931 10.7571 5.97931 10.4142 5.63644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningIconWhite);
export default __webpack_public_path__ + "static/media/runningIconWhite.48bb73479374ae11f8f9cb501ded66ae.svg";
export { ForwardRef as ReactComponent };